import { render, staticRenderFns } from "./OpportunityCount.vue?vue&type=template&id=38166621&"
import script from "./OpportunityCount.vue?vue&type=script&lang=js&"
export * from "./OpportunityCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports